import { FC } from 'react';
import styles from './styles.module.scss';
import { TPositionBlock, TSideBlock } from './model';
import { useTranslates } from 'providers/translates';

interface ClickAddBlockProps {
  addNewBlockText?: (position?: TPositionBlock, side?: TSideBlock, blockId?: string) => void;
  addNewBlockImage?: (position?: TPositionBlock, side?: TSideBlock, blockId?: string) => void;
  isNoClick?: boolean;
  isFullExample?: boolean;
}

export const ClickAddBlock: FC<ClickAddBlockProps> = ({
  addNewBlockText,
  isNoClick,
  addNewBlockImage,
  isFullExample = false,
}) => {
  const { translates: t } = useTranslates();
  const addTextAndPhotosBoxes = t?.quiltBuilderStepThree?.addTextAndPhotosBoxes;
  return ( 
      <>
      {isFullExample ? (
        <div className={`${styles.editorBlock__add} ${styles.editorBlock__wrapperFull}`}>        
          <div
            className={styles.editorBlock__addIcon}
            onClick={() => addNewBlockText && addNewBlockText()}
            style={{
              cursor: isNoClick ? 'default' : 'pointer',
            }}
          >
            <img src="/img/general/text-size-icon.png" alt="text-size" />
            <span>{addTextAndPhotosBoxes?.addTextLabel ?? 'Click here to add text'}</span>
          </div>
        </div>
      ) : (
      <div className={styles.editorBlock__add}>
        <div
          className={styles.editorBlock__addIcon}
          onClick={() => addNewBlockText && addNewBlockText()}
          style={{
            cursor: isNoClick ? 'default' : 'pointer',
          }}
        >
          <img src="/img/general/text-size-icon.png" alt="text-size" />
          <span>{addTextAndPhotosBoxes?.addTextLabel ?? 'Click here to add text'}</span>
        </div>
          <span className={styles.editorBlock__or}>OR</span>
          <div
            className={styles.editorBlock__addIcon}
            style={{
              cursor: isNoClick ? 'default' : 'pointer',
            }}
            onClick={() => addNewBlockImage && addNewBlockImage()}
          >
            <img src="/img/general/image-icon.png" alt="iamge-icon" />
            <span>{addTextAndPhotosBoxes?.addPhotoLabel ?? 'Click here to add images'}</span>
          </div>
        </div>
      )}
    </>
  );
};
